// extracted by mini-css-extract-plugin
export default {"vendorLogo":"vendorLogo__YjUyN","zolaLogo":"zolaLogo__NDE1Z"};